import { Button } from '@chakra-ui/react'
import { DefaultModal } from '@components/Modals'
import { PracticeTemplateList } from '../../../../components/Charting/DotPhraseTemplates/PracticeTemplateList'

// §E: Practice-level dot phrase template management modal — visible to practice super-admins only.
export const PracticeDotPhrasesModal = ({
  isOpen,
  onClose,
  practiceId,
}: {
  isOpen: boolean
  onClose: () => void
  practiceId: string
}) => (
  <DefaultModal
    isOpen={isOpen}
    onClose={onClose}
    header="Practice Dot Phrase Templates"
    size="md"
    render={() => <PracticeTemplateList practiceId={practiceId} />}
    renderFooter={({ onClose: close }) => (
      <Button size="sm" variant="ghost" onClick={close}>
        Close
      </Button>
    )}
  />
)
